import { Navigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../auth";
import { ErrorBox } from "../components/ErrorBox";

export function Login() {
  const { user, loading, authDisabled, signIn } = useAuth();
  const [err, setErr] = useState<unknown>(null);
  const [submitting, setSubmitting] = useState(false);

  // Local-first mode has no login: `roast serve` runs with auth off.
  if (authDisabled) return <Navigate to="/" replace />;
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;

  return (
    <div className="container" style={{ maxWidth: 440 }}>
      <div className="card">
        <h1 style={{ marginTop: 0 }}>RoastMCP</h1>
        <p className="muted">
          Personal roast analysis for the Aillio Bullet. Sign in with the
          Google account you authorized.
        </p>
        <button
          disabled={submitting}
          onClick={async () => {
            setErr(null);
            setSubmitting(true);
            try {
              await signIn();
            } catch (e) {
              setErr(e);
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {submitting ? "Signing in..." : "Sign in with Google"}
        </button>
        <ErrorBox error={err} />
      </div>
    </div>
  );
}
